/**
 * @file   src\components\Introduction\PendingIntroductionList.js
 * @brief  This file is responsible for pending introductions list.
 * @date   June, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
import React, { useRef } from "react";
import _ from "lodash";
import IntroductionDetail from "./IntroductionDetail";
import PendingIntroActions from "./PendingIntroActions";
import BlsIntroductionRow from "@/components/BlsIntroductionRow";
import { useCurrentWebsite } from "@/hooks/useCurrentWebsite";
import { INTRODUCTION_NOT_A_FIT_FROM_PENDING_LIST } from "../../constants/common";

const PendingIntroductionList = (props) => {
  const {
    list,
    count,
    updateIntroPageOnScroll,
    markNotFitModelShow,
    ViewIntroductionModalShow,
    acceptIntroduction,
    acceptingId,
    subtitle,
    network,
    showListing,
    title = "Pending",
  } = props;

  const scrollRef = useRef(null);
  const { isGitchaDefaultWebsite, mls } = useCurrentWebsite();
  const isBls = Boolean(mls) && !isGitchaDefaultWebsite;

  // To handle the page scroll for pagination
  const handleScroll = () => {
    const el = scrollRef.current;
    const scrollHeight = el.scrollHeight;
    const scrollTop = el.scrollTop;
    const clientHeight = el.clientHeight;
    if (
      scrollHeight !== clientHeight &&
      scrollTop !== 0 &&
      Math.abs(scrollHeight - (scrollTop + clientHeight)) <= 1
    ) {
      const section = "pending";
      updateIntroPageOnScroll(section);
    }
  };

  return (
    <>
      {count > 0 && (
        <div className="intro-list-sec">
          <div className="title-sec">
            <h5>
              {title} <span>({count})</span>
            </h5>
            {subtitle ? <p className="bls-intro-list__subtitle">{subtitle}</p> : null}
          </div>
          <div
            className={`property-block-scroll${isBls ? " bls-intro-list" : ""}`}
            onScroll={isBls ? undefined : handleScroll}
            ref={scrollRef}
          >
            {list.map((intro) => {
              const introId = _.get(intro, "IntroductionId", "");
              if (isBls) {
                return (
                  <BlsIntroductionRow
                    key={introId}
                    intro={intro}
                    network={network}
                    showListing={showListing}
                    onView={() => ViewIntroductionModalShow(introId)}
                    onMessage={() => acceptIntroduction(introId)}
                    onNotFit={() =>
                      markNotFitModelShow(
                        introId,
                        INTRODUCTION_NOT_A_FIT_FROM_PENDING_LIST
                      )
                    }
                    accepting={acceptingId === introId}
                    busy={!!acceptingId}
                  />
                );
              }
              return (
                <div className="property-block" key={introId}>
                  <div
                    className="property-info"
                    onClick={() => ViewIntroductionModalShow(introId)}
                  >
                    <IntroductionDetail introDetails={intro} />
                  </div>
                  <PendingIntroActions
                    onNotFit={() =>
                      markNotFitModelShow(
                        introId,
                        INTRODUCTION_NOT_A_FIT_FROM_PENDING_LIST
                      )
                    }
                    onView={() => ViewIntroductionModalShow(introId)}
                  />
                </div>
              );
            })}
            {isBls && list.length < count ? (
              <div className="bls-intro-list__more">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => updateIntroPageOnScroll("pending")}
                >
                  Show more
                </button>
              </div>
            ) : null}
          </div>
        </div>
      )}
    </>
  );
};
export default PendingIntroductionList;
